import application from "stimulus_application";
import RevealCustomizerController from "./reveal_customizer_controller";
import "./reveal_customizer.css";

application.register("reveal-customizer", RevealCustomizerController);
